import { Sidebar } from '../layout/Sidebar';
import { MailList } from '../layout/MailList';
import { MailViewer } from '../layout/MailViewer';
import { HelpHint } from '../ui/HelpHint';

/**
 * Vista Cartelle (classica): riusa il layout a pannelli originale della home
 * (Sidebar con albero cartelle + MailList + MailViewer), senza modifiche ai componenti.
 */
export function FoldersView() {
  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      {/* Intestazione minimale con aiuto contestuale della sezione Cartelle */}
      <div className="flex h-9 shrink-0 items-center gap-2 border-b border-zinc-800/80 px-4">
        <span className="text-sm font-semibold" style={{ color: 'var(--text)' }}>
          Cartelle
        </span>
        <HelpHint topic="folders" />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <MailList />
        <MailViewer />
      </div>
    </div>
  );
}
